exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-sales-orders-set-discount .modal-dialog{width:190px!important}#modal-sales-orders-set-discount .modal-content .button-row{margin-top:15px}", ""]);

// exports
